import { GlobalStyle } from "./theme/generalStyle";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/home";
import SinglePagel from "./pages/singlePage"

const App = () => {
  return (
    <>
      <GlobalStyle />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/page/:slug" element={<SinglePagel />} />
      </Routes>
    </>
  );
};

export default App;
